import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultKnowledgeHubContent } from '../../siteContent';
import { useCms, Text } from './cmsShared';

const AdminContentKnowledgeHub = () => {
  const { content, update, save, saving } = useCms('knowledgehub', defaultKnowledgeHubContent);
  const c = content;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#003366]">Knowledge Hub — Content</h2>
          <p className="text-sm text-gray-500">Edit the hero, formats heading, and bottom CTA. Articles are managed in the Articles tab.</p>
        </div>
        <Button onClick={save} disabled={saving} data-testid="cms-khub-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>

      <Accordion type="multiple" defaultValue={['hero', 'cta']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Hero Section</AccordionTrigger>
          <AccordionContent>
            <Text label="Eyebrow label" value={c.hero.eyebrow} onChange={(v) => update(['hero', 'eyebrow'], v)} />
            <Text label="Heading" value={c.hero.heading} onChange={(v) => update(['hero', 'heading'], v)} area />
            <Text label="Subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="formats" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Formats Section</AccordionTrigger>
          <AccordionContent>
            <Text label="Section heading" value={c.formatsHeading} onChange={(v) => update(['formatsHeading'], v)} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="cta" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Bottom CTA</AccordionTrigger>
          <AccordionContent>
            <Text label="Heading" value={c.bottomCta.heading} onChange={(v) => update(['bottomCta', 'heading'], v)} area />
            <Text label="Button label" value={c.bottomCta.button} onChange={(v) => update(['bottomCta', 'button'], v)} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex justify-end mt-6">
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>
    </div>
  );
};

export default AdminContentKnowledgeHub;
